import { memo } from "react";
import { onboardingApplicationStatus, OnboardingApplicationStatus } from "consts/onboarding";
import withChipStatus from "./withChipStatus";

export default memo(withChipStatus<OnboardingApplicationStatus>(
    new Map()
        .set(
            OnboardingApplicationStatus.Approved,
            onboardingApplicationStatus.get(OnboardingApplicationStatus.Approved)!
        )
        .set(
            OnboardingApplicationStatus.AwaitingReview,
            onboardingApplicationStatus.get(OnboardingApplicationStatus.AwaitingReview)!
        )
        .set(
            OnboardingApplicationStatus.Blocked,
            onboardingApplicationStatus.get(OnboardingApplicationStatus.Blocked)!
        )
        .set(
            OnboardingApplicationStatus.NotStarted,
            onboardingApplicationStatus.get(OnboardingApplicationStatus.NotStarted)!
        )
        .set(
            OnboardingApplicationStatus.RequestedChanges,
            onboardingApplicationStatus.get(OnboardingApplicationStatus.RequestedChanges)!
        )
        .set(
            OnboardingApplicationStatus.InReview,
            onboardingApplicationStatus.get(OnboardingApplicationStatus.InReview)!
        )
        .set(
            OnboardingApplicationStatus.Idle,
            onboardingApplicationStatus.get(OnboardingApplicationStatus.Idle)!
        )
        .set(
            OnboardingApplicationStatus.InProgress,
            onboardingApplicationStatus.get(OnboardingApplicationStatus.InProgress)!
        )
        .set(
            OnboardingApplicationStatus.Pending,
            onboardingApplicationStatus.get(OnboardingApplicationStatus.Pending)!
        )
        .set(
            OnboardingApplicationStatus.Rejected,
            onboardingApplicationStatus.get(OnboardingApplicationStatus.Rejected)!
        )
        .set(
            OnboardingApplicationStatus.Incomplete,
            onboardingApplicationStatus.get(OnboardingApplicationStatus.Incomplete)!
        )
));
